import fetchLogger from "./fetchLogger";

/**
 * GET /api/v1/issues — list, filter and search issues.
 * @param {Object} filters
 * @param {number} [filters.page]
 * @param {number} [filters.limit]
 * @param {number} [filters.statusCode]
 * @param {string} [filters.orderType]
 * @param {string} [filters.status]
 * @param {string} [filters.userRole]
 * @param {string} [filters.method]
 * @param {string} [filters.environment]
 * @param {string} [filters.endpointCalled]
 * @param {string} [filters.search]
 */
export default async function getIssues(filters = {}) {
  const result = {
    return: 0,
    msg: "Failed fetching issues",
    data: [],
    meta: { page: 1, limit: 20, total: 0, totalPages: 0 },
  };

  const params = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "" && value !== "all") {
      params[key] = value;
    }
  });

  const res = await fetchLogger({
    method: "GET",
    url: "/api/v1/issues",
    params,
  });

  if (res.ok) {
    result.return = 1;
    result.msg = "Successful";
    result.data = res.data?.data || [];
    result.meta = res.data?.meta || result.meta;
  } else {
    const message = res.data?.message;
    result.msg = Array.isArray(message) ? message.join(", ") : message || result.msg;
    result.error = res.data?.error;
    result.status = res.status;
  }

  return result;
}
